import router from "./../../router";
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

const state = {
    user_type: null,
};
 
const mutations = {
    setUserType(state, payload) {
        state.user_type = payload;
    },
    clearUserType(state) {
        state.user_type = null;
    }
};

const actions = {

    async exec_contact ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            noretryAuthAxios.post('/api/contact', {
                contact: payload.contact
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async init_update_user ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/init_update_user', {
                users: payload.users,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async update_user ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/update_user', {
                users: payload.users,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async new_staff ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/staff', {
                staff: payload.staff
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_staffs ({ commit }, payload) {
        // var params = '?type='+payload.type+'&sort='+payload.sort;
        return new axios.get('/api/staffs')
        .catch(error => {
            reject(error);
        })
    },

    async get_staff ({ commit }, payload) {
        return new axios.get('/api/staff/'+payload.id)
        .catch(error => {
            reject(error);
        })
    },

    async upd_staff ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/staff', {
                staff: payload.staff
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    async delete_staff ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/delete_staff', {
                staff: payload.staff
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_seller_detail ({ commit }, payload) {
        return new axios.get('/api/seller/detail/'+payload.id)
        .catch(error => {
            reject(error);
        })
    },

    async get_favorite_info ({ commit }, payload) {
        return new axios.get('/api/user/favorite_info')
        .catch(error => {
            reject(error);
        })
    },
    
    async get_admin_users ({ commit }, payload) {
        return new axios.get('/api/user/admin?type='+payload.type+'&identification_flg='+payload.identification_flg)
        .catch(error => {
            reject(error);
        })
    },

    async get_admin_user ({ commit }, payload) {
        return new axios.get('/api/user/admin/detail?id='+payload.id)
        .catch(error => {
            reject(error);
        })
    },

    async get_search ({ commit }, payload) {
        return new axios.get('/api/user/search'+payload.params)
        .catch(error => {
            reject(error);
        })
    },

    async current_user ({ commit }, payload) {
        return new axios.get('/api/current_user')
        .catch(error => {
            reject(error);
        });
    },

    async get_send_mails ({ commit }, payload) {
        return new axios.get('/api/send_mails')
        .catch(error => {
            reject(error);
        });
    },

    async post_send_mail ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/post_send_mail', {
                "send_mail": payload.sendForm,
                "test_flg": payload.testFlg,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    async upd_identification_flg ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/user/admin/identification_flg', {
                identification_flg: payload.identification_flg,
                users_id: payload.users_id,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    // async identification_download({ commit }, payload) {
    //     await new Promise((resolve, reject) => {
    //         axios.post('/api/user/admin/download', {
    //             download_file: payload.file_path,
    //         }).then(res => {
    //             resolve(res);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },

    async get_dashboard ({ commit }, payload) {
        return new axios.get('/api/user/dashboard')
        .catch(error => {
            reject(error);
        })
    },





































    
    async get_foot_prints ({ commit }, payload) {
        return new axios.get('/api/foot_print/list')
        .catch(error => {
            reject(error);
        });
    },

    async get_interests ({ commit }, payload) {
        return new axios.get('/api/interest/list')
        .catch(error => {
            reject(error);
        });
    },

    async post_interests ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/interest/request/'+payload.users_id, {
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js